import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const surveyResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getSurvey(to.params.id as string);
        to.meta.survey = res.data.data;
    } catch(error) {
        console.error('SURVEY_RESOLVER_ERROR');
        return { name: 'PatientProfile'  };
    }
}